import React from 'react';
import '../style/validationMessage.css'

const ValidationMessage = (props) => {
    return (
        <div className=" validationMessage-wrapper">{props.Label}</div>
    )
};

export default ValidationMessage;